import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BaseComponent } from '../../../../../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Reportv2Tab, Reportv2TabList } from '../../reportv2.const';
import { ReportService } from '../../../../../../common/services/Report.service';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts';
import { ExportCustomService } from 'app/common/services/ExportCustom.service';
import { Observable } from 'rxjs';
import { FieldService } from 'app/common/services/Field.service';

declare var require: any;
const moment = require('moment');
const HighchartsExporting = require('highcharts/modules/exporting');
declare var $: any;
@Component({
  selector: 'report-summary-agent',
  templateUrl: './summary-agent.component.html',
  styleUrls: ['./summary-agent.component.css'],
  providers: [ReportService, ExportCustomService, FieldService],
})
export class SummaryAgentComponent extends BaseComponent implements OnChanges, AfterViewInit {
  @Output() onChangeTab: EventEmitter<{ tab: any }> = new EventEmitter();
  public backgroundList = ['#fee4cb', '#e9e7fd', '#dbf6fd', '#ffd3e2', '#c8f7dc'];

  public optionsSourceNameList = {
    doing: 'Đang xử lý',
    close: 'Đã đóng',
    solved: 'Đã giải quyết',
    open: 'Mở',
    call_report: 'Cuộc gọi đã trả lời',
    ticket_report: 'Báo cáo ticket',
    all: 'Tất cả',
  };

  public exportType = {
    SourceTicket: 'SourceTicket',
    Customer: 'Customer',
    BestAgents: 'BestAgents',
    Effort: 'Effort',
    Groups: 'Groups',
  };
  public DataSourceTicketTotal = 0;
  public colorsOptionsSourceName = [
    '#099516',
    '#ffd061',
    '#05027c',
    '#096c86',
    '#706f6f',
    '#c5c7cd',
    '#a2ecff',
    '#ffd9d9',
    '#ff4240',
    '#000000',
  ];
  public lengedOptionsSourceName = [];

  public sourceKeys = [
    { key: 'CALL_OUTBOUND', label: 'Gọi điện ra' },
    { key: 'CALL_INBOUND', label: 'Khách gọi tới' },
    { key: 'zalo', label: 'Kênh Zalo' },
    { key: 'hand', label: 'Manually' },
    { key: 'facebook', label: 'Kênh Facebook' },
    { key: 'sms', label: 'SMS' },
    { key: 'chat', label: 'Kênh Chat' },
    { key: 'email', label: 'Kênh Email' },
    { key: 'import', label: 'Import' },
    { key: 'CALL_INTERNAL', label: 'Call_internal' },
  ];

  public ticketFields = [];
  public dataSummary: any = null;
  public optionsSourceData: any = {};
  public optionsCustomer: any = {};
  public readonly tabList = Reportv2TabList;
  public readonly Reportv2Tab = Reportv2Tab;
  public dataSummaryCallStatus = null;
  public dataSummaryTicketStatus = null;
  public isLoading = false;
  public modelFilter = {
    field: '',
    from_date: moment().subtract(6, 'days').startOf('day').toDate(), // Change to .toDate()
    to_date: moment().endOf('day').toDate(), // Change to .toDate()
  };
  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private reportService: ReportService,
    private exportCustomService: ExportCustomService,
    private fieldService: FieldService
  ) {
    super(changeDetector, toastr, modalService);
  }
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options;

  async ngOnInit() {
    HighchartsExporting(Highcharts);

    Observable.forkJoin([this.fieldService.allField({ target: 'ticket' })]).subscribe(data => {
      this.loadTicketFields(data[0]);
      this.loadData();
    });
  }

  onDateChange(type, event) {
    this.loadData();
  }

  loadTicketFields(res) {
    if (!res.error && res.status == 200) {
      res.data.forEach(e => {
        if (e.type === 'select') {
          this.ticketFields.push({
            key: e.key,
            title: e.title,
            display: false,
            data: e.data,
          });
        }
      });
      this.modelFilter.field = this.ticketFields[0].key;
      console.log(this.modelFilter.field, 'this.modelFilter.field');
    }
  }

  loadData() {
    // Get the first and last day of the current month
    this.isLoading = true;
    const payload = {
      fields: [this.modelFilter.field],
      date_to: moment(this.modelFilter.to_date).format('YYYY-MM-DD'),
      date_from: moment(this.modelFilter.from_date).format('YYYY-MM-DD'),
    };

    this.reportService.summaryPersonal(payload).subscribe(
      res => {
        this.generateDataCallStatus(res.data);
        this.generateDataTicketStatus(res.data);
        this.generateDataSourceTicket(res.data);
        this.isLoading = false;
      },
      error => {
        this.dataSummary = null;
        console.error('Error fetching summary data:', error);
        this.toastr.error('Đã xảy ra lỗi khi tải dữ liệu tổng hợp', 'Lỗi');
      }
    );
  }

  onFieldChange() {
    this.loadData();
  }

  generateDataCallStatus(data) {
    this.dataSummaryCallStatus = [];
    let datas = data.assign.call_status;
    if (datas) {
      Object.keys(datas).map(key => {
        let object = {
          height: 32,
          width: 32,
          value: datas[key],
          key,
          icon: `assets/images/icon_report_agent_${key}.png`,
        } as any;
        if (key == 'waiting') {
          object['title'] = 'Tổng số cuộc gọi';
          object['value'] = data.assign.total;
          object['iconBg'] = '#096c86';
          object['height'] = 25;
          object['width'] = 24;
        }
        if (key == 'reject') {
          (object['title'] = 'Số cuộc gọi bị từ chối'), (object['iconBg'] = '#979797');
          object['height'] = 25;
          object['width'] = 20;
        }
        if (key == 'answer') {
          object['title'] = 'Số cuộc gọi trả lời';
          object['iconBg'] = '#25d871';
        }
        if (key == 'miss') {
          object['title'] = 'Số cuộc gọi bị nhỡ';
          object['iconBg'] = '';
        }
        this.dataSummaryCallStatus.push(object);
      });
    }
  }

  generateDataTicketStatus(data) {
    let datas = data.assign.status;
    this.dataSummaryTicketStatus = [];
    let categories = [];
    if (datas) {
      Object.keys(datas).map(key => {
        let object = {
          value: datas[key],
          key,
        } as any;

        let title = '';

        if (key == 'closed') {
          title = 'Đã đóng';
        }
        if (key == 'doing') {
          title = 'Đang xử lý';
        }
        if (key == 'new') {
          title = 'Mới';
        }
        if (key == 'reopen') {
          title = 'Mở lại';
        }
        if (key == 'solved') {
          title = 'Đã xử lý';
        }
        categories.push(title);
        this.dataSummaryTicketStatus.push({
          ...object,
          title,
        });
      });
    }

    const TicketStatusElement = document.getElementById('TicketStatus');
    const widthCustomer = TicketStatusElement ? TicketStatusElement.offsetWidth : 200;
    this.dataSummaryTicketStatus = {
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: categories,
        labels: {
          style: {
            fontSize: '12px',
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: ' ',
        },
      },
      exporting: {
        enabled: false,
      },
      chart: {
        type: 'column',
        height: 400,
        width: widthCustomer - 100,
      },
      title: {
        text: ` `,
      },
      plotOptions: {
        column: {
          borderRadius: 16,
          pointWidth: 30, // Giảm độ rộng của cột
          dataLabels: {
            enabled: true,
            format: '{y}',
            style: {
              fontSize: '12px',
            },
          },
        },
      },
      series: [
        {
          name: '  ',
          colorByPoint: true,
          data: this.dataSummaryTicketStatus.map(e => e.value),
          colors: ['#F44336', '#0D47A1', '#26C6DA', '#FFEB3B', '#757575'],
        },
      ],
    };
  }

  generateDataSourceTicket(data) {
    let datas = [];
    this.DataSourceTicketTotal = 0;
    Object.keys(data.assign).map(key => {
      if (key !== 'call_status' && key !== 'status' && key !== 'total') {
        let keys = key.slice(0, -1);
        let index = key.charAt(key.length - 1);
        let field = this.ticketFields.find(e => e.key === keys);
        if (field) {
          this.DataSourceTicketTotal += data.assign[key];
          datas.push({
            name: field.title + ' ' + field.data[index],
            y: data.assign[key],
          });
        }
      }
    });
    const customerCustomerElement = document.getElementById('customerCustomer');
    const widthCustomer = customerCustomerElement ? customerCustomerElement.offsetWidth : 200;

    this.lengedOptionsSourceName = datas.map((value, index) => {
      return {
        name: value.name,
        count: value.y,
        bg: this.colorsOptionsSourceName[index],
      };
    });

    this.optionsSourceData = {
      credits: {
        enabled: false,
      },
      xAxis: {
        type: 'category',
        labels: {
          rotation: -45,
          style: {
            fontSize: '13px',
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: '   ',
        },
      },
      exporting: {
        enabled: false,
      },
      chart: {
        type: 'pie',
        height: 450,
        width: ((widthCustomer / 2) * 80) / 100,
      },
      title: {
        text: ` `,
      },
      plotOptions: {
        pie: {
          innerSize: '70%',
          dataLabels: {
            enabled: false,
            format: '<b >{point.name}</b>: {point.percentage:.1f} %',
          },
        },
      },
      series: [
        {
          name: 'Ticket',
          colorByPoint: true,
          data: datas,
        },
      ],
      colors: this.colorsOptionsSourceName,
      subtitle: {
        text: `<div>
                  <div style=" text-align: center;">
                  ${this.DataSourceTicketTotal}
                  </div>
                  <div style="font-size: 12px; color: #666666; text-align: center;">
                  Ticket
                  </div>
                </div>`,
        useHTML: true,
        align: 'center',
        verticalAlign: 'middle',
        y: 0,
        style: {
          fontSize: '30px',
          fontWeight: 'bold',
          color: '#000000',
        },
      },
    };
  }

  generateDataBestAgents() {
    this.dataSummary.best_agents = this.dataSummary.best_agents.map((item, index) => {
      item.background = this.backgroundList[index];
      item.avatar = item.avatar ? item.avatar : `assets/images/report_summary_agent_${index + 1}.png`;
      return item;
    });
  }

  generateDataGroups() {
    this.dataSummary.groups = this.dataSummary.groups.map((item, index) => {
      item.rate = Number(item.rate.toFixed(2));
      return item;
    });
  }

  generateDataEffort() {
    this.dataSummary.effort.done = Number(this.dataSummary.effort.done).toFixed(2);
    this.dataSummary.effort.processing = Number(this.dataSummary.effort.processing).toFixed(2);
  }

  generateDataCustomer() {
    const dates = [];

    let categories = [];
    this.dataSummary.customers.map(e => {
      dates.push(e.time);
      if (e.contacts && e.contacts.length >= 0) {
        e.contacts.map(a => {
          let check = categories.find(i => i === a.title);
          if (!check) {
            categories.push(a.title);
          }
        });
      }
    });

    categories = categories.map(value => {
      let object = {
        name: value,
        data: [],
      };
      this.dataSummary.customers.map(a => {
        let count = a.contacts.find(e => e.title === object.name);
        if (count) {
          object.data.push(count.count);
        } else {
          object.data.push(0);
        }
      });
      return object;
    });
    const customerSourceElement = document.getElementById('customerSource');
    if (!customerSourceElement) {
      return;
    }
    const width = customerSourceElement.offsetWidth;

    this.optionsCustomer = {
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            menuItems: [
              {
                text: 'Download PNG image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/png',
                    filename: `Báo cáo khách hàng theo nguồn ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download JPEG image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/jpeg',
                    filename: `Báo cáo khách hàng theo nguồn ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download PDF document',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'application/pdf',
                    filename: `Báo cáo khách hàng theo nguồn ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download SVG vector image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/svg+xml',
                    filename: `Báo cáo khách hàng theo nguồn ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download Excel',
                onclick: () => {
                  this.export(this.exportType.Customer);
                },
              },
            ],
            symbol: 'menu',
            symbolStroke: '#666666',
            symbolStrokeWidth: 3,
            symbolSize: 12,
            symbolX: 12.5,
            symbolY: 10.5,
            verticalAlign: 'top',
            y: -16,
          },
        },
      },
      title: { text: '   ' },
      chart: {
        type: 'areaspline', // Đổi thành "areaspline" để tạo hiệu ứng tô màu dưới đường
        height: 460,
        width: width - 50,
      },
      xAxis: {
        categories: dates, // Sử dụng danh sách ngày làm trục X
        title: {
          text: 'Ngày', // Nhãn trục X
        },
      },
      yAxis: {
        title: {
          text: 'Giá trị', // Nhãn trục Y
        },
        // Xóa phần plotBands ở đây
      },
      series: categories.map(series => ({
        ...series,
        fillOpacity: 0.3, // Thêm độ trong suốt cho phần diện tích được tô màu
      })),
      plotOptions: {
        areaspline: {
          marker: {
            enabled: false, // Tắt các điểm đánh dấu để đường trơn tru hơn
          },
        },
      },
      legend: {
        layout: 'horizontal',
        align: 'center', // Center the legend horizontally
        verticalAlign: 'bottom', // Place the legend at the bottom
        symbolHeight: 12,
        symbolWidth: 12,
        symbolRadius: 6,
        itemMarginTop: 5,
        itemStyle: {
          fontSize: '13px',
          fontWeight: 'normal',
        },
      },
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.initData().then((data) => {})
  }

  generateDatenow() {
    const currentDate = new Date();
    const month = currentDate.getMonth() + 1; // getMonth() trả về giá trị từ 0-11, nên cần cộng thêm 1
    const year = currentDate.getFullYear();
    const formattedDate = `Tháng ${month} - ${year}`;
    return formattedDate;
  }

  ngAfterViewInit(): void {}

  export(type): void {
    console.log(type, 'item');
    let exportDatas: any = {
      data: [],
    };
    let data: any = {};
    let title = '';
    switch (type) {
      case this.exportType.SourceTicket:
        this.optionsSourceData.series[0].data.forEach((data, index) => {
          let data_json: any = {};
          data_json['STT'] = index + 1;
          data_json['Nguồn'] = data.name;
          data_json['Số lượng'] = data.y;
          exportDatas.data.push(data_json);
        });

        data['title'] = 'Báo cáo ticket theo nguồn';
        data['column'] = ['STT', 'Nguồn', 'Số lượng'];
        data['isDate'] = true;
        data['dates'] =
          `Từ ngày: ${moment().startOf('month').format('YYYY-MM-DD')} - Đến ngày: ${moment().endOf('month').format('YYYY-MM-DD')}`;
        data['colWidths'] = [10, 24, 40];
        title = 'Báo cáo ticket theo nguồn';
        break;
      case this.exportType.Customer:
        const dates = this.optionsCustomer.xAxis.categories;
        const dataSeries = this.optionsCustomer.series;
        exportDatas.data = dates.map((item, index) => {
          let object = {
            STT: index + 1,
            'Thời gian': item,
          };
          dataSeries.map(e => {
            object[e.name] = e.data[index] || 0;
          });
          return object;
        });
        data['title'] = 'Báo cáo khách hàng theo nguồn';
        data['column'] = ['STT', 'Thời gian', ...dataSeries.map(value => value.name)];
        data['isDate'] = true;
        data['dates'] =
          `Từ : ${moment().subtract(11, 'months').startOf('month').format('YYYY-MM')} - Đến: ${moment().endOf('month').format('YYYY-MM')}`;
        data['colWidths'] = [10, 24, ...dataSeries.map(value => 24)];
        title = 'Báo cáo khách hàng theo nguồn';
        break;
      case this.exportType.Groups:
        const dataGroups = this.dataSummary.groups;
        console.log(dataGroups, 'dataGroups');
        exportDatas.data = dataGroups.map((item, index) => {
          let object: any = {
            STT: index + 1,
            'Phòng ban': item.name,
            'Tỉ lệ %': item.rate + '%',
          };
          return object;
        });
        data['title'] = 'Báo cáo hiệu suất phòng ban';
        data['column'] = ['STT', 'Phòng ban', 'Tỉ lệ'];
        data['isDate'] = true;
        data['dates'] =
          `Từ ngày: ${moment().startOf('month').format('YYYY-MM-DD')} - Đến ngày: ${moment().endOf('month').format('YYYY-MM-DD')}`;
        data['colWidths'] = [10, 40, 24];
        title = 'Báo cáo hiệu suất phòng ban';
        break;
      default:
        break;
    }

    this.exportCustomService.exportExcelCustom(
      exportDatas.data,
      title + ' ' + moment(new Date()).format('YYYY-MM-DD HH-mm'),
      data // Adding a default sheet name as the third argument
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/summary/summary-agent/summary-agent.component.ts